<template>
  <vSelect
    ref="select"
    v-model="localValue"
    v-bind="$attrs"
    :components="{ Deselect }"
    :selectable="option => !option.hasOwnProperty('group')"
    @input="handleFocus"
    @search:blur="$emit('blur')"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
  </vSelect>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },

  props: {
    value: {
      type: [Array, Object, String],
      default: () => [],
    },

    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchEl: null,
      Deselect: {
        render: function(h) {
          return <Icon id="cross" scale={0.4} />;
        },
      },
    };
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted() {
    this.searchEl = this.$el.querySelector('.vs__search');

    if (this.autofocus) {
      this.$nextTick(() => {
        this.searchEl.focus();
      });
    }
  },

  methods: {
    handleFocus() {
      if (this.$refs.select.$props.multiple) {
        this.$nextTick(() => {
          this.searchEl.focus();
        });
      }
    },
  },
};
</script>

<style lang="scss">
.v-select {
  position: relative;

  background-color: white;

  &:not(.v-select--taggable) {
    .vs__clear {
      display: none;
    }
  }
}

.vs__selected-options {
  padding: 2px 34px 2px 4px;
  width: 100%;
  display: flex;
  flex: 1 100%;
  flex-wrap: wrap;

  background-color: transparent;
  background-image: url('~@/assets/images/search-negative.svg');
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: calc(100% - 8px) 50%;
  border: 1px solid darken($alt-100, 5%);
  border-radius: 2px;

  .has-errors & {
    color: $danger-500;
    border-color: $danger-500;
  }
}

.vs__open-indicator {
  display: none;
}

.vs__search {
  padding: 7px 2px;
  width: 0;
  max-width: 100%;
  flex-grow: 1;

  font-family: $font-family-default;

  -moz-appearance: none;
  background: transparent;
  border: 0;

  outline: 0;
}

.vs__selected {
  padding: 5px 4px 3px 4px;

  .v-select--taggable & {
    margin: 2px 3px 2px 0;
    padding: 2px 12px 2px 10px;

    color: $brand-700;
    line-height: 24px;

    background-color: $brand-100;
    border: 1px solid $brand-300;
    border-radius: 24px;
  }

  .vs--single.vs--open & {
    position: absolute;
    opacity: 0.4;
  }

  .vs--single.vs--searching & {
    display: none;
  }
}

.vs__deselect {
  margin-left: 3px;
  padding: 0;

  color: $info-600;

  background: transparent;

  border: 0;
  border-radius: 0;

  cursor: pointer;
}

.vs__dropdown-menu {
  margin-top: -2px;
  padding: 0;
  width: 100%;
  max-height: 155px;
  display: none;
  overflow-y: auto;
  z-index: 1;

  position: absolute;
  top: 100%;
  left: 0;

  background: white;
  border: 1px solid darken($alt-100, 5%);

  list-style: none;

  // Work-around to show the dropwon only when typing because not yet handled by `vue-select`
  // See: https://github.com/sagalbot/vue-select/issues/108
  .vs--searching & {
    display: block;
  }
}

.vs__dropdown-option {
  padding: 8px 12px;

  color: $alt-600;
  font-size: 0.875rem;
  font-weight: bold;

  cursor: pointer;

  &:hover,
  &.vs__dropdown-option--highlight {
    color: $brand-700;
    background-color: $brand-50;
  }

  &:not(:last-child) {
    border-bottom: 1px solid darken($alt-100, 5%);
  }
}

.vs__no-options {
  padding: 8px 12px;
}
</style>
